import { BadgeCheck } from "lucide-react";

import { cn } from "../../../libs";

interface Props {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const sizeCfg: Record<NonNullable<Props["size"]>, string> = {
  sm: "w-[16px] h-[16px] md:w-[18px] md:h-[18px]",
  md: "w-4 h-4 md:w-6 md:h-6",
  lg: "w-6 h-6 md:w-8 md:h-8"
};

export const VerifiedBadge = ({ className, size = "md" }: Props) => {
  return (
    <div className={cn("bg-[#1D9BF0] rounded-full p-0.5 opacity-80", className)}>
      <BadgeCheck color={"#ffffff"} strokeWidth={1.5} className={sizeCfg[size]} />
    </div>
  );
};
